import React, { useState } from "react";
import "./../../../assets/css/GlobalHeaderActions.scss";
import { HiOutlineCog8Tooth } from "react-icons/hi2";
import { IoIosAddCircleOutline } from "react-icons/io";
import {
  setChatVisible,
  setIsOrbitUser,
  setShowProfileModal,
  setShowSettingsModal,
} from "../../../dispatchers/appDispatchers";
import {
  getSMS,
  getOrbitSessionDetail,
  setIsNewClinicComponent,
} from "../../../dispatchers/pharmacyServiceDispatchers";
import { useNavigate } from "react-router-dom";
import useTitanApp from "../../../hooks/useTitanApp";
import DarkThemeButton from "../../DarkThemeButton";
import ProfileButton from "../../ProfileButton";
import OrbitSession from "../../../pages/Orbit/components/OrbitSession";
import { Tooltip } from "@mui/material";
import { getAllGenerals } from "../../../dispatchers/generalDispatchers";
import SettingsModal from "../../SettingsModal";
import { Button } from "../../ui/button";
import { Settings } from "lucide-react";
import ProfileModal from "../../ProfileModal/ProfileModal";
import { Users } from "lucide-react";
import { getMemberById } from "../../../dispatchers/memberDispatchers";
import NotificationBell from "./NotificationBell";
export default function GlobalHeaderActions({
  headerTeamMembers,
  handleListViewClick,
  isListViewVisible,
  handleChatClick,
  handleBottomBarToggleClick,
  handlePharmacyMergeClick,
  handleSettingsClick,
  isPharmacyMergeEnabled,
  isToggleBottombarEnabled,
  isSettingsEnabled,
  isChatEnabled,
  isListViewEnabled,
  handleInviteMembersClick,
}) {
  const navigate = useNavigate();
  const { auth, appState, signout } = useTitanApp();
  const { user } = auth || {};

  const {
    darkMode,
    features,
    isChatVisible,
    isOrbitVisible,
    currentPharmacyId,
    isOrbitSwitch,
    userPermissions,
    isOrbitUser,
    showProfileModal,
    companyId,
  } = appState || {};
  const isDarkMode = darkMode || false;
  const { ifChatEnabled, ifSettingEnabled } = features || {};
  const userEmail = user?.email;
  const [activeIcon, setActiveIcon] = useState("");
  const [isSmsModal, setIsSmsModal] = useState(false);

  function showSmsModal() {
    getSMS().then((data) => {
      setIsSmsModal(true);
      return data;
    });
  }
  const handleSettingClick = () => {
    localStorage.setItem("settingBackUrl", window.location.href);
    setChatVisible(false);
    setIsNewClinicComponent(false);
    navigate(`/settings/general`);
  };
  function showOrbitSessionModal() {
    getOrbitSessionDetail(currentPharmacyId).then((data) => {
      // commented this code for now
      //setIsOrbitSession(true);
      return data;
    });
  }
  function navigateOrbitUser() {
    setIsOrbitUser(!isOrbitSwitch);
    navigate("/orbit");
  }
  function CloseSmsModal() {
    setIsSmsModal(false);
  }
  const handleSettingsModalButton = () => {
    setChatVisible(false);
    setIsNewClinicComponent(false);
    getAllGenerals(companyId);
    setShowSettingsModal(true);
  };

  return (
    <div className="global-header-actions">
      {/* {isPharmacyMergeEnabled && (
          <div
            className=""
            onClick={() => {
              setActiveIcon((prevActiveIcon) =>
                prevActiveIcon === "pharmacyMerge" ? "" : "pharmacyMerge"
              );
              handlePharmacyMergeClick();
            }}
          >
            <div
              className={` ${
                darkMode ? "chat-icon-dark" : "chat-icon-light"
              } ${activeIcon === "pharmacyMerge" ? "header-icon-active" : ""}`}
            >
              <svg
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 1H0V0H1V1ZM5 1H4V0H5V1ZM9 1H8V0H9V1ZM3 3H14V7H13V4H4V13H7V14H3V3ZM1 5H0V4H1V5ZM7.14645 7.14645C7.27485 7.01805 7.46276 6.96935 7.63736 7.01924L14.6374 9.01924C14.8408 9.07736 14.9856 9.25723 14.999 9.46837C15.0124 9.67952 14.8914 9.87623 14.697 9.95957L11.3808 11.3808L9.95957 14.697C9.87623 14.8914 9.67952 15.0124 9.46837 14.999C9.25723 14.9856 9.07736 14.8408 9.01924 14.6374L7.01924 7.63736C6.96935 7.46276 7.01805 7.27485 7.14645 7.14645ZM8.22801 8.22801L9.59441 13.0104L10.5404 10.803C10.591 10.685 10.685 10.591 10.803 10.5404L13.0104 9.59441L8.22801 8.22801ZM1 9H0V8H1V9Z"
                    fill={`${
                      activeIcon === "pharmacyMerge" || darkMode
                        ? "#fff"
                        : "#212121"
                    }`}
                  ></path>
                </g>
              </svg>
            </div>
            <div className="icon-wtext">
              <p>Enable Pharmacy Merge</p>
            </div>
          </div>
        )} */}
      {/* {isToggleBottombarEnabled && (
          <div
            className=""
            onClick={handleBottomBarToggleClick}
          >
            <div className="">
              <svg
                width="80px"
                height="80px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 5V10M9 14V19M4.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V6.6C21 6.03995 21 5.75992 20.891 5.54601C20.7951 5.35785 20.6422 5.20487 20.454 5.10899C20.2401 5 19.9601 5 19.4 5H4.6C4.03995 5 3.75992 5 3.54601 5.10899C3.35785 5.20487 3.20487 5.35785 3.10899 5.54601C3 5.75992 3 6.03995 3 6.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10ZM4.6 19H19.4C19.9601 19 20.2401 19 20.454 18.891C20.6422 18.7951 20.7951 18.6422 20.891 18.454C21 18.2401 21 17.9601 21 17.4V15.6C21 15.0399 21 14.7599 20.891 14.546C20.7951 14.3578 20.6422 14.2049 20.454 14.109C20.2401 14 19.9601 14 19.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V17.4C3 17.9601 3 18.2401 3.10899 18.454C3.20487 18.6422 3.35785 18.7951 3.54601 18.891C3.75992 19 4.03995 19 4.6 19Z"
                  stroke={darkMode ? "#fff" : "#000"}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="icon-wtext">
              <p>Toggle bottombar</p>
            </div>
          </div>
        )} */}
      {isListViewEnabled && (
        <Tooltip className="header-tooltip" title="New pharmacy code" arrow>
          <div>
            <IoIosAddCircleOutline
              color={darkMode ? "#bdbdbd" : "#0a0a0a"}
              onClick={handleInviteMembersClick}
            />
          </div>
        </Tooltip>
      )}

      {/* -----------Orbit Session--------------------------- */}
      {isOrbitVisible && <OrbitSession />}

      {isOrbitVisible && (
        <Tooltip className="header-tooltip" title="Orbit" arrow>
          <div
            className=""
            onClick={() => {
              navigateOrbitUser();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              height="24"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
              width="24"
            >
              <circle
                cx="12"
                cy="12"
                r="8"
                stroke={darkMode ? "#bdbdbd" : "#0a0a0a"}
                strokeWidth="1.5"
              />
              <path
                d="M17.4995 6.34835C19.7975 5.80967 21.4447 5.87208 21.8376 6.66002C22.5686 8.12616 18.6797 11.5491 13.1515 14.3053C7.62327 17.0616 2.5492 18.1074 1.81821 16.6413C1.4263 15.8553 2.36234 14.5067 4.16701 13.0001"
                stroke={darkMode ? "#bdbdbd" : "#0a0a0a"}
                strokeWidth="1.5"
              />
            </svg>
          </div>
        </Tooltip>
      )}

      {isOrbitVisible && (
        <Tooltip
          title="Orbit Session"
          className="header-tooltip orbit-session"
          arrow
        >
          <div
            onClick={() => {
              showOrbitSessionModal();
            }}
          >
            <svg
              width="72"
              height="19"
              viewBox="0 0 72 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M66.9502 16.562C66.9502 16.2267 67.012 15.9087 67.1359 15.6081C67.2597 15.308 67.4322 15.0476 67.6536 14.8265C67.8747 14.6057 68.1356 14.4336 68.4367 14.3097C68.7374 14.1863 69.056 14.1241 69.3925 14.1241C69.7284 14.1241 70.047 14.1863 70.3481 14.3097C70.6488 14.4336 70.9098 14.6057 71.1312 14.8265C71.3524 15.0476 71.5249 15.308 71.6489 15.6081C71.7725 15.9087 71.8347 16.2267 71.8347 16.562C71.8347 16.8979 71.7725 17.2159 71.6489 17.516C71.5249 17.8167 71.3524 18.0771 71.1312 18.2978C70.9098 18.5188 70.6488 18.6911 70.3481 18.8146C70.047 18.9379 69.7284 19 69.3925 19C69.056 19 68.7374 18.9379 68.4367 18.8146C68.1356 18.6911 67.8747 18.5188 67.6536 18.2978C67.4322 18.0771 67.2597 17.8167 67.1359 17.516C67.012 17.2159 66.9502 16.8979 66.9502 16.562Z"
                fill={darkMode ? "#bdbdbd" : "#0a0a0a"}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.50414 18.8409V4.37238H0V0H11.7071V4.37238H8.12335V18.8409H3.50414Z"
                fill={darkMode ? "#bdbdbd" : "#0a0a0a"}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.1138 18.8409H17.7329V0H13.1138V18.8409Z"
                fill={darkMode ? "#bdbdbd" : "#0a0a0a"}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.8293 18.8409V4.37238H19.3252V0H31.0323V4.37238H27.4485V18.8409H22.8293Z"
                fill={darkMode ? "#bdbdbd" : "#0a0a0a"}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M38.279 6.17435L36.3941 12.2162H40.1374L38.279 6.17435ZM34.1909 18.8409H29.147L36.3942 0H40.164L47.4112 18.8409H42.3142L41.3851 16.1115H35.1467L34.1909 18.8409Z"
                fill={darkMode ? "#bdbdbd" : "#0a0a0a"}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M48.2336 18.8409V0H52.4015L59.3302 10.4672V0H63.9493V18.8409H59.8878L52.8527 8.34725V18.8409H48.2336Z"
                fill={darkMode ? "#bdbdbd" : "#0a0a0a"}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M66.9502 16.562C66.9502 16.2267 67.012 15.9087 67.1359 15.6081C67.2597 15.308 67.4322 15.0476 67.6536 14.8265C67.8747 14.6057 68.1356 14.4336 68.4367 14.3097C68.7374 14.1863 69.056 14.1241 69.3925 14.1241C69.7284 14.1241 70.047 14.1863 70.3481 14.3097C70.6488 14.4336 70.9098 14.6057 71.1312 14.8265C71.3524 15.0476 71.5249 15.308 71.6489 15.6081C71.7725 15.9087 71.8347 16.2267 71.8347 16.562C71.8347 16.8979 71.7725 17.2159 71.6489 17.516C71.5249 17.8167 71.3524 18.0771 71.1312 18.2978C70.9098 18.5188 70.6488 18.6911 70.3481 18.8146C70.047 18.9379 69.7284 19 69.3925 19C69.056 19 68.7374 18.9379 68.4367 18.8146C68.1356 18.6911 67.8747 18.5188 67.6536 18.2978C67.4322 18.0771 67.2597 17.8167 67.1359 17.516C67.012 17.2159 66.9502 16.8979 66.9502 16.562Z"
                fill={darkMode ? "#bdbdbd" : "#0a0a0a"}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0V4.37238H3.50425V18.8409H8.12335V4.37238H11.7072V0H0Z"
                fill={darkMode ? "#bdbdbd" : "#0a0a0a"}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.1138 18.8409H17.7329V0H13.1138V18.8409Z"
                fill={darkMode ? "#bdbdbd" : "#0a0a0a"}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.3252 0V4.37238H22.8294V18.8409H27.4485V4.37238H31.0324V0H19.3252Z"
                fill={darkMode ? "#bdbdbd" : "#0a0a0a"}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M36.3942 0L29.147 18.8409H34.1909L35.1466 16.1115H41.385L42.3141 18.8409H47.4112L40.1639 0H36.3942ZM38.2789 6.17435L40.1373 12.2163H36.3941L38.2789 6.17435Z"
                fill={darkMode ? "#bdbdbd" : "#0a0a0a"}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M59.3302 0V10.4672L52.4015 0H48.2336V18.8409H52.8527V8.34725L59.8877 18.8409H63.9494V0H59.3302Z"
                fill={darkMode ? "#bdbdbd" : "#0a0a0a"}
              />
            </svg>
          </div>
        </Tooltip>
      )}

      {/* -----------------End Orbit Session-------------------------- */}

      {!isOrbitUser && isSettingsEnabled && ifSettingEnabled && (
        <div
          className=""
          onClick={() => {
            setActiveIcon((prevActiveIcon) =>
              prevActiveIcon === "settings" ? "" : "settings",
            );
            setChatVisible(false);
            handleSettingsClick();
            setIsNewClinicComponent(false);
          }}
        >
          <div
            className={` ${darkMode ? "chat-icon-dark" : "chat-icon-light"} ${
              activeIcon === "settings" ? "header-icon-active" : ""
            }`}
          >
            <HiOutlineCog8Tooth size={30} />
          </div>
          <div className="icon-wtext">
            <p>Settings</p>
          </div>
        </div>
      )}

      {/* {isChatEnabled && ifChatEnabled && (
          <div className="">
            <div
              className={` ${
                darkMode ? "chat-icon-dark" : "chat-icon-light"
              } ${isChatVisible === true ? "header-icon-active" : ""}`}
              onClick={async () => {
                toggleChat();
                handleChatClick();
              }}
            >
              {isChatVisible === true ? (
                <FaCommentSlash
                  color={`${isChatVisible === true ? "#fff" : "#212121"}`}
                />
              ) : (
                <BsChatText
                  color={`${isChatVisible === true ? "#fff" : "#212121"}`}
                />
              )}
            </div>
            <div className="icon-wtext">
              <p>Messages</p>
            </div>
          </div>
        )}
        {isListViewEnabled && (
          <div
            className="header_list-view header-icons"
            onClick={() => {
              setChatVisible(false);
              handleListViewClick();
            }}
          >
            <div
              className={` ${
                darkMode ? "chat-icon-dark" : "chat-icon-light"
              } ${isListViewVisible === true ? "header-icon-active" : ""}`}
            >
              <svg
                width="15"
                height="15"
                viewBox="0 0 11 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.33599 7.70117C2.86749 7.70117 3.29835 8.13209 3.29835 8.66367V10.0375C3.29835 10.5691 2.86749 11 2.33599 11H0.962361C0.430863 11 0 10.5691 0 10.0375V8.66367C0 8.13209 0.430863 7.70117 0.962361 7.70117H2.33599ZM2.33599 8.52617H0.962361C0.886432 8.52617 0.82488 8.58773 0.82488 8.66367V10.0375C0.82488 10.1134 0.886432 10.175 0.962361 10.175H2.33599C2.41192 10.175 2.47347 10.1134 2.47347 10.0375V8.66367C2.47347 8.58773 2.41192 8.52617 2.33599 8.52617ZM4.26083 8.8H10.5876C10.8153 8.8 11 8.98468 11 9.2125C11 9.42133 10.8448 9.59392 10.6435 9.62123L10.5876 9.625H4.26083C4.03305 9.625 3.84839 9.44032 3.84839 9.2125C3.84839 9.00367 4.00356 8.83108 4.20487 8.80377L4.26083 8.8H10.5876H4.26083ZM2.33599 3.85058C2.86749 3.85058 3.29835 4.28151 3.29835 4.81308V6.18692C3.29835 6.71849 2.86749 7.14942 2.33599 7.14942H0.962361C0.430863 7.14942 0 6.71849 0 6.18692V4.81308C0 4.28151 0.430863 3.85058 0.962361 3.85058H2.33599ZM2.33599 4.67558H0.962361C0.886432 4.67558 0.82488 4.73715 0.82488 4.81308V6.18692C0.82488 6.26286 0.886432 6.32442 0.962361 6.32442H2.33599C2.41192 6.32442 2.47347 6.26286 2.47347 6.18692V4.81308C2.47347 4.73715 2.41192 4.67558 2.33599 4.67558ZM4.26083 4.95H10.5876C10.8153 4.95 11 5.13468 11 5.3625C11 5.57133 10.8448 5.74392 10.6435 5.77123L10.5876 5.775H4.26083C4.03305 5.775 3.84839 5.59032 3.84839 5.3625C3.84839 5.15367 4.00356 4.98108 4.20487 4.95377L4.26083 4.95H10.5876H4.26083ZM2.33599 0C2.86749 0 3.29835 0.430926 3.29835 0.9625V2.33633C3.29835 2.86791 2.86749 3.29883 2.33599 3.29883H0.962361C0.430863 3.29883 0 2.86791 0 2.33633V0.9625C0 0.430926 0.430863 0 0.962361 0H2.33599ZM2.33599 0.825H0.962361C0.886432 0.825 0.82488 0.886561 0.82488 0.9625V2.33633C0.82488 2.41227 0.886432 2.47383 0.962361 2.47383H2.33599C2.41192 2.47383 2.47347 2.41227 2.47347 2.33633V0.9625C2.47347 0.886561 2.41192 0.825 2.33599 0.825ZM4.26083 1.1H10.5876C10.8153 1.1 11 1.28468 11 1.5125C11 1.72133 10.8448 1.89392 10.6435 1.92123L10.5876 1.925H4.26083C4.03305 1.925 3.84839 1.74032 3.84839 1.5125C3.84839 1.30367 4.00356 1.13108 4.20487 1.10377L4.26083 1.1H10.5876H4.26083Z"
                  fill={`${
                    isListViewVisible === true || darkMode ? "#fff" : "#212121"
                  }`}
                />
              </svg>
            </div>

            <div className="icon-wtext">
              <p>List View</p>
            </div>
          </div>
        )} */}

      <Button
        variant="ghost"
        size="sm"
        onClick={() => {
          handleSettingsModalButton();
        }}
      >
        <Settings
          className="w-4 h-4"
          color={darkMode ? "#bdbdbd" : "#0a0a0a"}
        />
      </Button>
      {/* Profile Modal */}
      <ProfileModal
        open={showProfileModal}
        onOpenChange={setShowProfileModal}
        isDarkMode={isDarkMode}
      />

      <NotificationBell />
      <DarkThemeButton />
      <ProfileButton />
    </div>
  );
}
